{
  "SET_NEW_PASSWORD": {
    "TITLE": "Establecer nueva contraseña",
    "PASSWORD": {
      "LABEL": "Contraseña",
      "PLACEHOLDER": "Contraseña",
      "ERROR": "La contraseña es demasiado corta."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirmar contraseña",
      "PLACEHOLDER": "Confirmar contraseña",
      "ERROR": "Las contraseñas no coinciden."
    },
    "API": {
      "SUCCESS_MESSAGE": "Contraseña cambiada con éxito.",
      "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
    },
    "CAPTCHA": {
      "ERROR": "La verificación ha caducado. Por favor, resuelve el captcha de nuevo."
    },
    "SUBMIT": "Enviar"
  }
}
